import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const horizontalNavViewEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(/* webpackChunkName: "async-horizontal-nav-view-entrypoint" */ './src/ui/index.tsx'),
		{ includeInShellOnlySsrBundle: true },
	),
	getPreloadProps: () => ({}),
});
